import {BillingData} from '@/types/billing-data';

export const mapFrontendBillingDataToBackend = (billingData: BillingData) => {
  return {
    name: billingData.name || null,
    email: billingData.email || null,
    street: billingData.address.street || null,
    streetNumber: billingData.address.streetNumber || null,
    postalCode: billingData.address.postalCode || null,
    city: billingData.address.city || null,
    country: billingData.address.country || null,
    subscription: billingData.subscription || null
  };
};
